core-tooltip {
  display: inline-block;
}

.core-tooltip {
  --information-button-padding: var(--number-spacing-4xsmall);
  --information-button-radius: var(--number-radius-xsmall);
}

.core-tooltip-content {
  --tooltip-padding: var(--number-spacing-3xsmall) var(--number-spacing-2xsmall);
  --tooltip-background-color: var(--color-neutral-background-strong);
  --tooltip-color: var(--color-neutral-content-medium);
}

.core-tooltip.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.core-tooltip .core-tooltip-content {
  display: none;
}

.core-tooltip-content {
  padding: var(--tooltip-padding);
  max-width: 25ch;
  width: max-content;
  z-index: 9999;
  border-radius: var(--number-radius-small);
  position: absolute;
  text-align: center;
  box-sizing: border-box;
  background-color: var(--tooltip-background-color);
  color: var(--tooltip-color);
  opacity: 1;
  box-shadow: var(--effect-drop-medium);
  transform: translateY(0), translateX(0);
  transition: opacity var(--motion-duration-medium) var(--motion-easing-move),
  transform var(--motion-duration-medium) var(--motion-easing-move);
  pointer-events: none;
}

.core-tooltip-content .pointer {
  position: absolute;
  display: block;
  pointer-events: none;
}

.core-tooltip-content .pointer svg {
  display: block;
  position: absolute;
  fill: var(--tooltip-background-color);
  pointer-events: none;
}

/* Top Direction */

.core-tooltip-content.tooltip--top i {
  top: 100%;
  width: 1.25rem;
  height: 0.5rem;
}

/* Right Direction */

.core-tooltip-content.tooltip--right i {
  width: 0.5rem;
  height: 1.25rem;
}

/* Bottom Direction */

.core-tooltip-content.tooltip--bottom i {
  bottom: 100%;
  width: 1.25rem;
  height: 0.5rem;
}

/* Left Direction */

.core-tooltip-content.tooltip--left i {
  width: 0.5rem;
  height: 1.25rem;
}


/* Default button for tooltip */
.core-tooltip .information-button {
  display: flex;
  border: none;
  outline: none;
  padding: var(--information-button-padding);
  border-radius: var(--information-button-radius);
  pointer-events: none;
  transition: background-color var(--motion-duration-fast) var(--motion-easing-move);
}

.core-tooltip .information-button:focus-visible {
  outline: 2px solid var(--color-global-border-focus);
  outline-offset: 2px;
}

.core-tooltip.tooltip-closed .information-button {
  background-color: transparent;
}

.core-tooltip.tooltip-open .information-button {
  background-color: var(--color-neutral-background-soft);
}

.core-tooltip-content.tooltip-content--hidden {
  opacity: 0;
}

.core-tooltip-content.tooltip-content--hidden.tooltip-content--top {
  transform: translateY(0.25rem);
}

.core-tooltip-content.tooltip-content--hidden.tooltip-content--right {
  transform: translateX(-0.25rem);
}

.core-tooltip-content.tooltip-content--hidden.tooltip-content--bottom {
  transform: translateY(-0.25rem);
}

.core-tooltip-content.tooltip-content--hidden.tooltip-content--left {
  transform: translateX(0.25rem);
}
